import api from "!../../../../../../releases/f3bc3948fba4891f7866c530529be672dae9b0d0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/f3bc3948fba4891f7866c530529be672dae9b0d0/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/f3bc3948fba4891f7866c530529be672dae9b0d0/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/f3bc3948fba4891f7866c530529be672dae9b0d0/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};